module.exports = __webpack_public_path__ + "img/b.8e5a402c.jpg";